import { Entry } from "contentful";
import {
  ContentBlock,
  EstimatedTimeHeader,
  FieldID,
  GuideTypes,
  Metadata,
} from "../models";
import { convertToHtmlString, findContent, parseIntoImage } from "../utils";

export const createEstimatedTimeHeader = (
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
): EstimatedTimeHeader => {
  const estimatedTime = findContent(
    entries,
    FieldID.guideContainer.estimatedTimeHeader.estimatedTime,
    guideType,
  );
  const estimatedTimeIcon = findContent(
    entries,
    FieldID.guideContainer.estimatedTimeHeader.estimatedTimeIcon,
    guideType,
  );
  const numSteps = findContent(
    entries,
    FieldID.guideContainer.estimatedTimeHeader.numSteps,
    guideType,
  );
  const numStepsIcon = findContent(
    entries,
    FieldID.guideContainer.estimatedTimeHeader.numStepsIcon,
    guideType,
  );

  return {
    estimatedTime: convertToHtmlString(estimatedTime?.fields.richContent),
    estimatedTimeIcon: parseIntoImage(
      estimatedTimeIcon?.fields.richContent.content[0].data,
    ),
    numSteps: convertToHtmlString(numSteps?.fields.richContent),
    numStepsIcon: parseIntoImage(
      numStepsIcon?.fields.richContent.content[0].data,
    ),
  };
};
